/**
 * @typedef {Object} ImportField
 * @property {string} id - O identificador único do campo.
 * @property {string} name - O nome programático do campo.
 * @property {string} label - O rótulo de exibição do campo.
 * @property {string} [type='TEXT'] - O tipo de dado do campo (e.g., 'TEXT', 'TELEPHONE').
 * @property {boolean} isRequired - Indica se o campo é obrigatório para a importação.
 */

/**
 * Objeto contendo as configurações de campos padrão para diferentes entidades de importação.
 * Cada chave representa uma entidade e seu valor é um array de objetos ImportField
 * que definem os campos esperados para aquela entidade.
 *
 * @type {Object.<string, ImportField[]>}
 */
export const defaultImportFields = {
  /**
   * Campos padrão para importação de Contas CRM.
   * @type {ImportField[]}
   */
  CRM_ACCOUNT: [
    {
      id: 'name',
      name: 'name',
      label: 'Nome',
      type: 'TEXT',
      isRequired: true
    },
    {
      id: 'phone',
      name: 'phone',
      label: 'Telefone',
      type: 'TELEPHONE',
      isRequired: true
    },
    {
      id: 'responsibleLogin',
      name: 'responsibleLogin',
      label: 'Responsável',
      isRequired: false
    },
    {
      id: 'customerPortfolioId',
      name: 'customerPortfolioId',
      label: 'Categoria dos Clientes',
      isRequired: true
    }
  ],
  /**
   * Campos padrão para importação de Contatos CRM.
   * @type {ImportField[]}
   */
  CRM_CONTACT: [
    {
      id: 'name',
      name: 'name',
      label: 'Nome',
      type: 'TEXT',
      isRequired: true
    },
    {
      id: 'phone',
      name: 'phone',
      label: 'Telefone',
      type: 'TELEPHONE',
      isRequired: true
    },
    {
      id: 'email',
      name: 'email',
      label: 'Email',
      type: 'TEXT',
      isRequired: false
    }
  ],
  /**
   * Campos padrão para importação de Leads CRM.
   * @type {ImportField[]}
   */
  CRM_LEAD: [
    {
      id: 'name',
      name: 'name',
      label: 'Nome',
      isRequired: true
    },
    {
      id: 'email',
      name: 'email',
      label: 'Email',
      isRequired: false
    },
    {
      id: 'phone',
      name: 'phone',
      label: 'Telefone',
      type: 'TELEPHONE',
      isRequired: false
    },
    {
      id: 'responsibleLogin',
      name: 'responsibleLogin',
      label: 'Responsável',
      isRequired: false
    }
  ],
  /**
   * Campos padrão para importação de Oportunidades CRM.
   * @type {ImportField[]}
   */
  CRM_OPPORTUNITY: [
    {
      id: 'title',
      name: 'title',
      label: 'Título',
      isRequired: true
    },
    {
      id: 'amount',
      name: 'amount',
      label: 'Valor',
      isRequired: false
    },
    {
      id: 'expected_closure',
      name: 'expected_closure',
      label: 'Previsão de encerramento',
      isRequired: false
    },
    {
      id: 'responsibleLogin',
      name: 'responsibleLogin',
      label: 'Responsável',
      isRequired: false
    }
  ],
  /**
   * Campos padrão para importação de Listas de Transmissão.
   * @type {ImportField[]}
   */
  BROADCAST_LIST: [
    {
      id: 'name',
      name: 'name',
      label: 'Nome',
      type: 'TEXT',
      isRequired: true
    },
    {
      id: 'phone',
      name: 'phone',
      label: 'Telefone',
      type: 'TELEPHONE',
      isRequired: true
    },
    {
      id: 'email',
      name: 'email',
      label: 'Email',
      type: 'TEXT',
      isRequired: false
    },
    {
      id: 'contextParams',
      name: 'contextParams',
      label: 'Parâmetros de Contexto',
      type: 'TEXT',
      isRequired: false
    }
  ],
  /**
   * Campos padrão para importação de Números Bloqueados do WhatsApp.
   * @type {ImportField[]}
   */
  WHATS_APP_BLOCKED_NUMBERS: [
    {
      id: 'telephone',
      name: 'telephone',
      label: 'Telefone',
      isRequired: true,
      type: 'TELEPHONE'
    },
    {
      id: 'reason',
      name: 'reason',
      label: 'Motivo do bloqueio',
      isRequired: false
    }
  ],
  CRM_PRODUCTS: [
    {
      id: 'name',
      name: 'name',
      label: 'Nome',
      isRequired: true
    },
    {
      id: 'basePrice',
      name: 'basePrice',
      label: 'Preço Base',
      isRequired: true
    },
    {
      id: 'description',
      name: 'description',
      label: 'Descrição',
      isRequired: true
    },
    {
      id: 'code',
      name: 'code',
      label: 'Código',
      isRequired: true
    },
    {
      id: 'externalId',
      name: 'externalId',
      label: 'ID Externo',
      isRequired: false
    }
  ]
};
